import { render, staticRenderFns } from "./CreatePermiso.vue?vue&type=template&id=06fc7f3d&"
import script from "./CreatePermiso.vue?vue&type=script&lang=js&"
export * from "./CreatePermiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports